<template>
  <a-form ref="formRef" :model="postParams" v-bind="layout">
    <a-row>
      <a-col :span="10">
        <a-form-item label="KEY值" name="itemKey" :labelCol="{ span: 4 }">
          <a-input
            v-model:value="postParams.itemKey"
            placeholder="请输入"
            @change="
              e =>
                inputLengthCut({
                  val: e.target.value,
                  key: 'itemKey',
                  len: 255
                })
            "
          />
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="Basics" name="defaultValue">
          <a-input
            v-model:value="postParams.defaultValue"
            placeholder="请输入编码"
            @change="
              e =>
                inputLengthCut({
                  val: e.target.value,
                  key: 'defaultValue',
                  len: 10
                })
            "
          />
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item style="text-align: right;justify-content: right;">
          <a-space>
            <a-button type="default" @click="resetParams">重置</a-button>
            <a-button type="primary" @click="resetPagination">查询</a-button>
          </a-space>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>
<script>
import { inject, toRefs, reactive } from 'vue'
export default {
  setup() {
    const state = reactive({
      layout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      }
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
